import { render, staticRenderFns } from "./RevisarSancion.vue?vue&type=template&id=56eb1f37&"
import script from "./RevisarSancion.vue?vue&type=script&lang=js&"
export * from "./RevisarSancion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports